package br.com.vvrefeicoes.portal.feature.operacional

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import br.com.vvrefeicoes.portal.core.ui.components.AppModalCard
import br.com.vvrefeicoes.portal.core.ui.theme.AppSpacing
import br.com.vvrefeicoes.portal.core.util.formatIsoDate
import br.com.vvrefeicoes.portal.domain.model.ComplaintStatus
import br.com.vvrefeicoes.portal.domain.model.CustomerComplaint
import org.jetbrains.compose.resources.stringResource
import portalvv.shared.generated.resources.Res
import portalvv.shared.generated.resources.operational_complaint_col_date
import portalvv.shared.generated.resources.operational_complaint_col_description
import portalvv.shared.generated.resources.operational_complaint_col_directorate
import portalvv.shared.generated.resources.operational_complaint_col_manager
import portalvv.shared.generated.resources.operational_complaint_col_nature
import portalvv.shared.generated.resources.operational_complaint_col_owner
import portalvv.shared.generated.resources.operational_complaint_col_restaurant
import portalvv.shared.generated.resources.operational_complaint_col_service
import portalvv.shared.generated.resources.operational_complaint_col_shift
import portalvv.shared.generated.resources.operational_complaint_col_status
import portalvv.shared.generated.resources.operational_complaint_col_supplier
import portalvv.shared.generated.resources.operational_complaint_col_time
import portalvv.shared.generated.resources.operational_complaint_col_treatment
import portalvv.shared.generated.resources.operational_complaint_status_closed
import portalvv.shared.generated.resources.operational_complaint_status_in_progress
import portalvv.shared.generated.resources.operational_complaint_status_open
import portalvv.shared.generated.resources.operational_complaint_status_resolved
import portalvv.shared.generated.resources.operational_complaint_view_title

/** Modal somente leitura com todos os dados de uma reclamação. */
@Composable
fun ComplaintViewDialog(
    record: CustomerComplaint,
    onDismiss: () -> Unit,
) {
    AppModalCard(title = stringResource(Res.string.operational_complaint_view_title), onDismiss = onDismiss) {
        Column(
            modifier = Modifier.fillMaxWidth(),
            verticalArrangement = Arrangement.spacedBy(AppSpacing.space12),
        ) {
            ViewField(stringResource(Res.string.operational_complaint_col_date), formatIsoDate(record.date))
            ViewField(stringResource(Res.string.operational_complaint_col_time), record.time)
            ViewField(stringResource(Res.string.operational_complaint_col_directorate), record.directorate)
            ViewField(stringResource(Res.string.operational_complaint_col_manager), record.managerName)
            ViewField(stringResource(Res.string.operational_complaint_col_restaurant), record.restaurant)
            ViewField(stringResource(Res.string.operational_complaint_col_service), record.service)
            ViewField(stringResource(Res.string.operational_complaint_col_status), complaintStatusLabel(record.status))
            ViewField(stringResource(Res.string.operational_complaint_col_supplier), record.supplier)
            ViewField(stringResource(Res.string.operational_complaint_col_shift), record.shift)
            ViewField(stringResource(Res.string.operational_complaint_col_nature), record.nature)
            ViewField(stringResource(Res.string.operational_complaint_col_description), record.description)
            ViewField(stringResource(Res.string.operational_complaint_col_treatment), record.treatment)
            ViewField(stringResource(Res.string.operational_complaint_col_owner), record.treatmentOwner)
        }
    }
}

@Composable
private fun ViewField(
    label: String,
    value: String,
) {
    Column(verticalArrangement = Arrangement.spacedBy(AppSpacing.space4)) {
        Text(
            text = label,
            style = MaterialTheme.typography.labelMedium,
            color = MaterialTheme.colorScheme.onSurfaceVariant,
        )
        Text(
            text = value.ifBlank { "-" },
            style = MaterialTheme.typography.bodyMedium,
            color = MaterialTheme.colorScheme.onSurface,
        )
    }
}

@Composable
internal fun complaintStatusLabel(status: ComplaintStatus): String =
    when (status) {
        ComplaintStatus.OPEN -> stringResource(Res.string.operational_complaint_status_open)
        ComplaintStatus.IN_PROGRESS -> stringResource(Res.string.operational_complaint_status_in_progress)
        ComplaintStatus.RESOLVED -> stringResource(Res.string.operational_complaint_status_resolved)
        ComplaintStatus.CLOSED -> stringResource(Res.string.operational_complaint_status_closed)
    }
